import { Injectable } from '@angular/core';
import { Project } from '../../models/project';
import { DbService } from '../db/db.service';

@Injectable({
  providedIn: 'root'
})
export class SearchBarService {

  	constructor(
		private dbService: DbService
	) { }

	async getByFilter(filter: string, projectId: string, modelPath: string) {
		const snapshot = await this.dbService.firestore.collection(Project.PATH).doc(projectId).collection(modelPath).orderBy('name').startAt(filter).endAt(filter +'\uf8ff').get();
		if (snapshot.empty) {
			return null;
		}
		return snapshot.docs;
	}

}
